import type { RocketMeta } from '../rocket-configs';
import { AdventuresHeader } from './adventures';
import type { AdventureHeaderProps } from './adventure';
import { AdventureHeader } from './adventure';

export function RocketHeader({
  config,
  completedSteps,
  onClose,
  onBack,
}: Omit<AdventureHeaderProps, 'config'> & { config?: RocketMeta | null }) {
  if (config == null) {
    return <AdventuresHeader onClose={onClose} />;
  }
  return <AdventureHeader config={config} completedSteps={completedSteps} onClose={onClose} onBack={onBack} />;
}
